import React, { FC, useMemo, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import _sortBy from 'lodash/sortBy';
import { useDrawerSearchFilterNameOrCategory, useDrawerFiltersCounts, useDrawerGlobalLoader } from '@minecraft.drawer';
import ErrorMessage from '@minecraft.error-message';
import {
  FormItem,
  useFiltersLabel,
  FiltersNameEnum,
  generateSelectOptionsBasedOnField,
  FilterDrawerType,
} from '@blocs.filter';
import { FiltersCategoryNameEnum, FiltersCountNameEnum } from '../../shared/types';
import { MultipleBirth } from '../../FilterDrawerCollection';
import { QUERY_MULTIPLE_BIRTH } from './MultipleBirthCategoryGraphQL';

interface Props {
  type: FilterDrawerType;
}

const MultipleBirthCategory: FC<Props> = ({ type }) => {
  const filtersLabelOfAudience = useFiltersLabel(type);

  const { data, error, loading } = useQuery(QUERY_MULTIPLE_BIRTH);

  const { isCategoryMatchedSearch, assignOptionsToCategoryFilters } = useDrawerSearchFilterNameOrCategory(
    FiltersCategoryNameEnum.multipleBirth
  );
  const { filtersCounts } = useDrawerFiltersCounts();

  const multipleBirthOptions = useMemo(() => {
    return generateSelectOptionsBasedOnField(
      _sortBy(data?.multipleBirths, 'name'),
      'name',
      false,
      filtersCounts?.[FiltersCountNameEnum.multipleBirthId]
    );
  }, [data, filtersCounts]);

  useDrawerGlobalLoader(loading);

  useEffect(() => {
    if (multipleBirthOptions.length > 0) {
      assignOptionsToCategoryFilters({
        [FiltersNameEnum.multipleBirth]: multipleBirthOptions,
      });
    }
  }, [multipleBirthOptions]);

  if (error) {
    return <ErrorMessage error={error} />;
  }

  return (
    isCategoryMatchedSearch && (
      <FormItem $fullWidth $marginValue={2}>
        <MultipleBirth
          name={FiltersNameEnum.multipleBirth}
          label={filtersLabelOfAudience[FiltersNameEnum.multipleBirth]}
        />
      </FormItem>
    )
  );
};

export default MultipleBirthCategory;
